<template>
  <v-menu
    v-model="showPopup"
    offset-y
    :nudge-bottom="12"
    :nudge-left="385"
    :close-on-content-click="false"
    :max-width="$vuetify.breakpoint.xsOnly ? 'calc(100vw - 32px)' : 412"
    :min-width="$vuetify.breakpoint.xsOnly ? 'calc(100vw - 32px)' : 412"
    :left="$vuetify.breakpoint.xsOnly ? '12px' : undefined"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        data-test="notificaitons"
        class="mr-3"
        v-on="on"
        @click="
          hasNew = false;
          showPopup = true;
        "
      >
        <v-badge
          offset-y="2px"
          offset-x="1px"
          color="#D50000"
          dot
          :value="hasNew"
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-sheet min-height="50" v-if="$vuetify.breakpoint.xsOnly">
      <notification-list
        :notifications="listItems"
        @close="showPopup = false"
      />
    </v-sheet>
    <v-sheet v-else max-width="412" min-width="300">
      <notification-list
        :notifications="listItems"
        @close="showPopup = false"
      />
    </v-sheet>
  </v-menu>
</template>

<script>
import { ref, computed, onMounted, watch, inject } from '@vue/composition-api';

import { useNotificationsCurrentUser } from '@/api/notifications/notificationsCurrentUser';

import NotificationList from './notificationList';
import useAuth from '@/api/auth/index';
import { invoke, until } from '@vueuse/core';

export default {
  name: 'Notifications',
  components: {
    NotificationList
  },
  setup(props, { root }) {
    const { profile, user } = useAuth();
    const {
      load,
      subscribeVariables,
      listItems,
      loadMore,
      variables,
      hasNew
    } = useNotificationsCurrentUser();
    const showPopup = ref(false);
    const formattedNotifications = ref([]);
    const isMobile = computed(() => root.$vuetify.breakpoint.smAndDown);

    const programName = computed(() => {
      return profile.value?.objectProperties.find(
        item => item.key === 'programName'
      )?.value;
    });

    watch(
      () => profile,
      value => {
        if (value) {
          const programName = profile.value?.objectProperties?.find(
            item => item.key === 'programName'
          )?.value;

          if (user.value?.id && programName) {
            variables.value.condition.deliveryPath = programName;
            variables.value.condition.user = user.value?.id;
            subscribeVariables.value.deliveryPath = programName;
            subscribeVariables.value.deliveryUser = user.value?.id;
            load();
          }
        }
      },
      {
        immediate: true,
        deep: true
      }
    );

    return {
      formattedNotifications,
      hasNew,
      isMobile,
      showPopup,
      loadMore,
      listItems,
      user,
      programName
    };
  }
};
</script>
